import { axios } from 'common/utils'
import { EventParam, EventsState } from '../types/entities/event'
import {
  Collection,
  SpecialEvent,
  SpecialEventResponse,
  SpecialEventsResponse,
} from '../types/entities/api/specialEvent'
import { EventDetailParam } from 'common/types/entities/event'
import { ProductParam } from 'common/types/params'
import { StoreProducts } from 'common/types/entities/store'
import hostConfig from 'common/config'
import { getSubVerticalPath, getVerticalPath } from 'common/constants'

export async function fetchSpecialEvents(eventParam: EventParam): Promise<EventsState> {
  let events: SpecialEvent[] = []
  if (!eventParam) {
    return {
      events,
      hasMore: false,
      totalCount: 0,
    }
  }

  const response = await axios.get<SpecialEventsResponse>(`/v1/special-events`, {
    params: eventParam,
  })

  let totalCount
  if (response && response.data.bSuccess && response.data.htReturnValue) {
    events = response.data.htReturnValue.itemsInPage
    totalCount = response.data.htReturnValue.paging.totalCount || 0
  }

  const hasMore = events.length >= eventParam.pageSize

  return {
    events,
    hasMore,
    totalCount,
  }
}

export async function fetchSpecialEvent(detailParam: EventDetailParam): Promise<SpecialEvent> {
  const { eventId } = detailParam

  const result = await axios.get<SpecialEvent>(`/v1/special-events/${eventId}`)
  return result && result.data
}

export async function fetchCollections(detailParam: EventDetailParam): Promise<Collection[]> {
  const { eventId } = detailParam
  const result = await axios.get<Collection[]>(`/v1/special-events/${eventId}/collections`)
  return result && result.data
}

export async function fetchProductsByIds(params: ProductParam): Promise<StoreProducts> {
  const { eventId, page } = params

  const result = await axios.get<StoreProducts>(`/v1/special-events/${eventId}/products`, {
    params,
  })

  if (result && result.data) {
    result.data.products.forEach(product => {
      product['groupKey'] = page
    })
  }

  return result && result.data
}

export const getEventDetailUrl = (event: SpecialEvent, includeHost: boolean, isMobile: boolean) => {
  const { pc, mobile } = hostConfig.shoppingWebUri
  const config = isMobile ? mobile : pc
  return `${includeHost ? config.host : ''}${
    event.subVertical ? getSubVerticalPath(event.subVertical) : getVerticalPath(event.vertical)
  }/event/${event.id}`
}

export async function fetchRandomSpecialEvent(
  subVertical: string,
  injectionItem: boolean,
  excludeIds: number[],
): Promise<SpecialEvent> {
  const response = await axios.get<SpecialEventResponse>(`/v1/special-events/random-one`, {
    params: {
      subVertical,
      injectionItem,
      excludeIds,
    },
  })

  if (response && response.data && response.data.bSuccess) {
    return response.data.htReturnValue
  }
}
